import { render, staticRenderFns } from "./AffHedgeAppBaseForm.vue?vue&type=template&id=9b94646a&scoped=true&"
import script from "./AffHedgeAppBaseForm.vue?vue&type=script&lang=js&"
export * from "./AffHedgeAppBaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b94646a",
  null
  
)

export default component.exports